
import config from '../views/login/config/remote_api';
import PathUri from '@/utils/path_uri';
import axios from "@/plugins/http/axios.js";

const _pathUri = new PathUri(config.port, config.context);

export const service = {
  
  postPassword : ( idGroup, idEmpresa, userId, firstPassword, secondPassword, forgottenPassword ) => {
  
    return axios({
      method: 'post',
      url: `${config.baseUrl+_pathUri.generateUri()+idGroup}/login/createPassword`,
      headers: {
        'Content-Type': 'application/json',
        'idEmpresa': idEmpresa
      },
      data: {
        userId: userId,
        firstPassword: firstPassword,
        secondPassword: secondPassword,
        forgottenPassword: forgottenPassword
      },
      redirect: 'follow'
    })
  }
};